import ReactDOM from 'react-dom/client';
import React from 'react';
export const NavButton =  ()=>{
    return (
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" 
            data-bs-target="#navbar-content" aria-controls="navbar-content" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
        </button>
    )
}